import React, { Fragment, useEffect, useRef } from "react";
import { makeStyles } from "@mui/styles";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: "bold",
    marginRight: "8px",
  },
  tableData: {
    display: "flex",
  },
}));

export default function RegistrationFormPreview({ valObj = {}, setActiveDocNodeId, isFromFaculty = false }) {
  const regForm = useRef(null);
  const classes = useStyles();
  useEffect(() => {
    if (!isFromFaculty) {
      setActiveDocNodeId("registration-form-container");
    }
  }, [])

  const renderContent = () => {
    const weightage1Map = {
      regStuCollege: "Regular student of St. Andrew's College",
      stuInterCollege: "Student of St. Andrew's Inter College",
      none: "None",
    };
    const weightage2Map = {
      "sports-national-level": "Sport National Level",
      "sports-state-inter-university-level":
        "Sport State & Inter University Level",
      "sports-district-level": "Sport District Level",
      "NCC-C-grade": "NCC C-Grade",
      "NCC-B-grade": "NCC B-Grade",
      "NSS-2-camp-and-240-hrs-work": "NSS 2 Camp and 240 hrs work",
      "NSS-1-camp-and-240-hrs-work": "NSS 1 Camp and 240 hrs work",
      "scout-guides-rovers-ranger": "Scout/Guides/Rovers/Ranger",
      "physical-handicap": "Physical Handicap",
      "alumni-association": "Alumni/ae Association",
    };
    
    const weightage2List = valObj?.weightage2?.map((item) => {
      return weightage2Map[item];
    }).join(", ");

    let subjectName = '';
    if (valObj.subjects) {
      if (typeof valObj.subjects === 'string') {
        subjectName = `(${valObj.subjects})`;
      }
    }
    return (
      <div
        ref={regForm}
        style={{ display: "contents", fontSize: "12pt" }}
        id="registration-static-form"
      >
        <div
          id="registration-form-container"
          className={isFromFaculty ? 'reg-form' : ''}
          style={{ width: "98%", alignSelf: "center" }}
        >
          <table
            className="table table-vcenter mb-0 text-nowrap table-bordered"
            id="personalInformation"
          >
            <tbody>
              <tr>
                <td colSpan="3">
                  <div className={classes.tableData}>
                    <p className={classes.label}>Course applied for:</p>
                    {valObj.registrationType}
                  </div>
                </td>
              </tr>
              <tr>
                <td className={classes.label}>Course Name</td>
                <td colSpan="2">{`${valObj.courseName} ${subjectName}`}</td>
              </tr>
              <tr>
                <td colSpan="3" style={{ textAlign: "center", fontWeight: "bold" }}>
                  Personal Information
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <p className={classes.label}>First Name</p>
                    {valObj.full_name.first_name}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>Middle Name</p>
                    {valObj.full_name.middle_name}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>Last Name</p>
                    {valObj.full_name.last_name}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <p className={classes.label}>Father's Name</p>
                    {valObj.father_name}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>Mother's Name</p>
                    {valObj.mother_name}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>Form number</p>
                    {valObj.formNumber}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <p className={classes.label}>Date of birth</p>
                    {moment(valObj.date_of_birth).format("DD-MM-YYYY")}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>Gender</p>
                    {valObj.gender}
                  </div>
                </td>
                <td rowSpan="4" style={{ width: "33%" }}>
                  <div>
                    <p className={classes.label}>Profile picture</p>
                    <img
                      width="80%"
                      src={valObj.document_urls?.passport_photo}
                      alt="profile"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <p className={classes.label}>Religion</p>
                    {valObj.religion}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>Category</p>
                    {valObj.category}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <p className={classes.label}>Minority Category</p>
                    {valObj.isMinority}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>EWS Category</p>
                    {valObj.isEWS_category}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <p className={classes.label}>Nationality</p>
                    {valObj.nationality}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>Annual family income</p>
                    {valObj.annual_family_income}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <p className={classes.label}>Domicile (State)</p>
                    {valObj.domicile}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>Domicile Certificate No.</p>
                    {valObj.domicile_certitificate_number}
                  </div>
                </td>
                <td rowSpan="3" style={{ width: "33%" }}>
                  <div>
                    <p className={classes.label}>Signature</p>
                    <img width="80%" src={valObj.document_urls?.signature} alt="signature" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <p className={classes.label}>Aadhaar card available?</p>
                    {valObj.isAadharAvailable}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>Aadhaar No.</p>
                    {valObj.aadhar_number}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <p className={classes.label}>Special Category</p>
                    {valObj.special_category}
                  </div>
                </td>
                <td>
                  {/* <div>
                    <p className={classes.label}>Special Category</p>
                    {valObj.special_category}
                  </div> */}
                </td>
              </tr>

              {/* <tr>
                <td>6</td>
                <td>7</td>
                <td>8</td>
              </tr> */}
            </tbody>
          </table>
          <table
            className="table table-vcenter mb-0 text-nowrap table-bordered"
            id="addressInformation"
          >
            <tbody>
              <tr>
                <td colSpan="2" style={{ textAlign: "center", fontWeight: "bold" }}>
                  Address Information
                </td>
              </tr>
              <tr>
                <td className={classes.label}>Permanent Address</td>
                <td className={classes.label}>Correspondence Address</td>
              </tr>
              <tr>
                <td id="permanent">
                  <div>
                    <p className={classes.label}>State</p>
                    <p style={{ marginBottom: "12px" }}>{valObj.state}</p>
                  </div>
                  <div>
                    <p className={classes.label}>District</p>
                    <p style={{ marginBottom: "12px" }}>{valObj.district}</p>
                  </div>
                  <div>
                    <p className={classes.label}>Pincode</p>
                    <p style={{ marginBottom: "12px" }}>{valObj.pincode}</p>
                  </div>
                  <div>
                    <p className={classes.label}>Address</p>
                    <p style={{ marginBottom: "12px" }}>{valObj.address}</p>
                  </div>
                </td>
                <td id="correspondence">
                  <div>
                    <p className={classes.label}>State</p>
                    <p style={{ marginBottom: "12px" }}>
                      {valObj.correspondence_state}
                    </p>
                  </div>
                  <div>
                    <p className={classes.label}>District</p>
                    <p style={{ marginBottom: "12px" }}>
                      {valObj.correspondence_district}
                    </p>
                  </div>
                  <div>
                    <p className={classes.label}>Pincode</p>
                    <p style={{ marginBottom: "12px" }}>
                      {valObj.correspondence_pincode}
                    </p>
                  </div>
                  <div>
                    <p className={classes.label}>Address</p>
                    <p style={{ marginBottom: "12px" }}>
                      {valObj.correspondence_address}
                    </p>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <p className={classes.label}>Mobile number</p>
                    {valObj.mobile_number}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>Email</p>
                    {valObj.email_id}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <br />
          <table
            className="table table-vcenter mb-0 table-bordered"
            id="educationalDetails"
          >
            <tbody>
              <tr>
                <td colSpan="3" style={{ textAlign: "center", fontWeight: "bold" }}>
                  Educational details
                </td>
              </tr>
              <tr>
                <td colSpan="3" className={classes.label}>
                  Secondary / Metriculation / High School (10th)
                </td>
              </tr>
              <tr>
                <td style={{ width: "33%" }}>
                  <div>
                    <p className={classes.label}>Passing year</p>
                    {valObj.high_school_passing_year}
                  </div>
                </td>
                <td style={{ width: "33%" }}>
                  <div>
                    <p className={classes.label}>Board Name</p>
                    {valObj.high_school_board}
                  </div>
                </td>
                <td style={{ width: "33%" }}>
                  <div>
                    <p className={classes.label}>Roll number</p>
                    {valObj.high_school_roll_number}
                  </div>
                </td>
              </tr>
              <tr>
                <td style={{ width: "33%" }}>
                  <div>
                    <p className={classes.label}>Maximum marks</p>
                    {valObj.high_school_max_marks}
                  </div>
                </td>
                <td style={{ width: "33%" }}>
                  <div>
                    <p className={classes.label}>Marks obtained</p>
                    {valObj.high_school_marks_obtained}
                  </div>
                </td>
                <td style={{ width: "33%" }}>
                  <div>
                    <p className={classes.label}>School Name</p>
                    {valObj.high_school_school_name}
                  </div>
                </td>
              </tr>

              <tr>
                <td colSpan="3" className={classes.label}>
                  Sr. Secondary / Intermediate (12th) / Equivalent
                </td>
              </tr>

              <tr>
                <td>
                  <div>
                    <p className={classes.label}>Passing status</p>
                    {valObj.intermediate_passing_status !== "--Select--" ? valObj.intermediate_passing_status : "Passed"}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>School Name</p>
                    {valObj.intermediate_school_name}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>Passing year</p>
                    {valObj.intermediate_passing_year}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <p className={classes.label}>Board Name</p>
                    {valObj.intermediate_board_name}
                  </div>
                </td>
                <td>
                  <div>
                    <p className={classes.label}>Roll number</p>
                    {valObj.intermediate_roll_number}
                  </div>
                </td>
                {valObj.intermediate_passing_status === "Passed" && (
                  <td>
                    <div>
                      <p className={classes.label}>Maximum marks</p>
                      {valObj.intermediate_max_marks}
                    </div>
                  </td>
                )}
              </tr>
              {valObj.intermediate_passing_status === "Passed" && (
                <tr>
                  <td>
                    <div>
                      <p className={classes.label}>Marks obtained</p>
                      {valObj.intermediate_marks_obtained}
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <br />
          {valObj.registrationType === "Masters" && (
            <Fragment>
              <table
                className="table table-vcenter mb-0 text-nowrap table-bordered"
                id="mastersDetails"
              >
                <tbody>
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center", fontWeight: "bold" }}>
                      Masters details
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="3" className={classes.label}>
                      Graduation
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <p className={classes.label}>
                          State from where graduated
                        </p>
                        {valObj.graduation_state}
                      </div>
                    </td>
                    <td>
                      <div>
                        <p className={classes.label}>
                          Degree earned university
                        </p>
                        {valObj.graduation_degree_earned_university}
                      </div>
                    </td>
                    <td>
                      <div>
                        <p className={classes.label}>Graduated year</p>
                        {valObj.graduation_passing_year}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <p className={classes.label}>Roll no.</p>
                        {valObj.graduation_roll_number}
                      </div>
                    </td>
                    <td>
                      <div>
                        <p className={classes.label}>Maximum marks</p>
                        {valObj.graduation_max_marks}
                      </div>
                    </td>
                    <td>
                      <div>
                        <p className={classes.label}>Marks obtained</p>
                        {valObj.graduation_marks_obtained}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="3" className={classes.label}>
                      Post graduation
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <p className={classes.label}>
                          State from where post graduated
                        </p>
                        {valObj.post_graduation_state}
                      </div>
                    </td>
                    <td>
                      <div>
                        <p className={classes.label}>
                          Degree earned university
                        </p>
                        {valObj.post_graduation_degree_earned_university}
                      </div>
                    </td>
                    <td>
                      <div>
                        <p className={classes.label}>Post graduated year</p>
                        {valObj.post_graduation_passing_year}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <p className={classes.label}>Roll no.</p>
                        {valObj.post_graduation_roll_number}
                      </div>
                    </td>
                    <td>
                      <div>
                        <p className={classes.label}>Maximum marks</p>
                        {valObj.post_graduation_max_marks}
                      </div>
                    </td>
                    <td>
                      <div>
                        <p className={classes.label}>Marks obtained</p>
                        {valObj.post_graduation_marks_obtained}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="3" className={classes.label}>
                      Other graduation details
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <p className={classes.label}>Qualified degree</p>
                        {valObj.qualifying_degree}
                      </div>
                    </td>
                    <td>
                      <div>
                        <p className={classes.label}>Enroll roll no.</p>
                        {valObj.enroll_roll_number}
                      </div>
                    </td>
                    <td>
                      <div>
                        <p className={classes.label}>Course system</p>
                        {valObj.course_system}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        <p className={classes.label}>Course duration</p>
                        {valObj.course_duration}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
            </Fragment>
          )}
          <table
            className="table table-vcenter mb-0 table-bordered"
            id="weightageDetails"
          >
            <tbody>
              <tr>
                <td colSpan="2" style={{ textAlign: "center", fontWeight: "bold" }}>
                  Weightage details
                </td>
              </tr>
              <tr>
                <td className={classes.label}>Weightage 1</td>
                <td className={classes.label}>Weightage 2</td>
              </tr>
              <tr>
                <td>{weightage1Map[valObj.weightage1]}</td>
                <td>{weightage2List}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return <Fragment>{renderContent()}</Fragment>;
}
